import CryptoJS from "crypto-js";

// Shared by the login token and the signed query params the API expects.
// The key, mode and padding are part of the contract with the server: do not change them.
const KEY = CryptoJS.enc.Utf8.parse("edariworkmenkmen");
const OPTIONS = { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 };

/** Returns the AES-encrypted text, or undefined when there is nothing to encrypt. */
export const encryptText = (text) => {
  if (!text) return undefined;
  return CryptoJS.AES.encrypt(text, KEY, OPTIONS).toString();
};

/** Decrypts text produced by `encryptText` (throws on malformed input, like CryptoJS). */
export const decryptText = (cipherText) =>
  CryptoJS.AES.decrypt(cipherText, KEY, OPTIONS).toString(CryptoJS.enc.Utf8);
